// Merkt sich die Einstiegs-URL mit Kampagnenparametern, damit sie nach einer späteren
// Cookie-Zustimmung an GA4 übergeben werden kann. Sendet selbst nichts an Google.
const STORAGE_KEY = 'landing_url'
const CAMPAIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid']

export function captureLandingUrl() {
    try {
        const params = new URLSearchParams(window.location.search)
        if (!CAMPAIGN_PARAMS.some(p => params.has(p)))
            return
        if (!sessionStorage.getItem(STORAGE_KEY))
            sessionStorage.setItem(STORAGE_KEY, window.location.href)
    } catch (e) {
        // Storage blockiert - ohne Landing-URL weitermachen
    }
}

export function consumeLandingUrl() {
    try {
        const url = sessionStorage.getItem(STORAGE_KEY)
        sessionStorage.removeItem(STORAGE_KEY)
        return url
    } catch (e) {
        return null
    }
}
